module.exports = __webpack_public_path__ + "img/flux360-information-Button.0d9e653d.svg";